module.exports = __webpack_public_path__ + "img/ko.7c4a415d.svg";